module.exports = __webpack_public_path__ + "static/media/pxiByp8kv8JHgFVrLGT9Z1JlFd2JQEl8qw.a6ff41d1.woff2";